/**
 * Tester profile — entered on first launch (first name, last name, phone,
 * default language) and kept in localStorage. In the real product this
 * comes from the Nexum account (SSO).
 */
export type UserProfile = {
  firstName: string;
  lastName: string;
  phone: string;
  locale: "fr" | "es";
  /** Tester access code — only required when the server enforces one. */
  accessCode?: string;
};

const STORAGE_KEY = "nora-profile";

export const loadProfile = (): UserProfile | null => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as UserProfile;
    if (!parsed.firstName || !parsed.phone) return null;
    return parsed;
  } catch {
    return null;
  }
};

export const saveProfile = ({ profile }: { profile: UserProfile }) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(profile));
};

export const fullName = ({ profile }: { profile: UserProfile }) =>
  `${profile.firstName} ${profile.lastName}`.trim();

export const initialsOf = ({ profile }: { profile: UserProfile }) =>
  `${profile.firstName[0] ?? ""}${profile.lastName[0] ?? ""}`.toUpperCase() || "–";
